// Email Notifications via EmailJS

const EMAILJS_CONFIG = {
  SERVICE_ID:    process.env.REACT_APP_EMAILJS_SERVICE_ID  || '',
  TEMPLATE_ID:   process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
  PUBLIC_KEY:    process.env.REACT_APP_EMAILJS_PUBLIC_KEY  || '',
  MANAGER_EMAIL: process.env.REACT_APP_MANAGER_EMAIL       || 'vbhattad@gmail.com',
};

const loadEmailJSScript = () =>
  new Promise((resolve, reject) => {
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js';
    script.onload  = resolve;
    script.onerror = () => reject(new Error('Failed to load EmailJS SDK'));
    document.head.appendChild(script);
  });

export const sendTicketNotification = async (ticket, property) => {
  if (!EMAILJS_CONFIG.SERVICE_ID) {
    console.log('EmailJS not configured - skipping ticket notification.');
    return { success: false, reason: 'not_configured' };
  }
  try {
    if (!window.emailjs) await loadEmailJSScript();
    window.emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
    await window.emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      {
        to_email:    EMAILJS_CONFIG.MANAGER_EMAIL,
        from_name:   ticket.renter,
        ticket_id:   '#' + ticket.id,
        title:       ticket.title,
        property:    property ? (property.address || 'Unknown Property') : 'Unknown Property',
        unit:        ticket.unit,
        category:    ticket.category,
        priority:    ticket.priority,
        description: ticket.description,
        date:        ticket.date,
        photo_count: ticket.photos ? ticket.photos.length : 0,
      }
    );
    console.log('Ticket notification sent');
    return { success: true };
  } catch (error) {
    console.error('Ticket notification failed:', error);
    return { success: false, reason: error.message };
  }
};

// Wraps notice HTML in an email-safe container with inline styles
var buildNoticeEmailHtml = function(noticeHtml, toName, noticeType, property, unit, effectiveDate, landlordName) {
  return [
    '<!DOCTYPE html><html><head><meta charset="utf-8"/>',
    '<style>',
    'body{font-family:Arial,sans-serif;font-size:13px;color:#000;margin:0;padding:20px;background:#f4f4f4}',
    '.wrap{max-width:700px;margin:0 auto;background:#fff;border-radius:8px;overflow:hidden}',
    '.top{background:#1a1a1a;padding:20px 28px}',
    '.logo{font-size:20px;font-weight:800;color:#fff}',
    '.logo span{color:#E8622A}',
    '.sub{color:#aaa;font-size:13px;margin-top:4px}',
    '.body{padding:28px}',
    '.intro{margin:0 0 20px;font-size:14px;color:#333;line-height:1.6}',
    '.notice-wrap{border:1px solid #ddd;border-radius:6px;padding:24px;background:#fafafa;margin-bottom:20px}',
    '.notice-wrap .header{text-align:center;border-bottom:2px solid #000;padding-bottom:12px;margin-bottom:16px}',
    '.notice-wrap h1{font-size:16px;margin:0 0 4px}',
    '.notice-wrap h2{font-size:13px;font-weight:normal;margin:0}',
    '.notice-wrap .form-no{font-size:11px;color:#444;margin-top:4px}',
    '.notice-wrap .section{margin-bottom:16px}',
    '.notice-wrap .section-title{font-weight:bold;font-size:12px;border-bottom:1px solid #ccc;padding-bottom:3px;margin-bottom:10px}',
    '.notice-wrap .row{display:flex;gap:16px;margin-bottom:8px;flex-wrap:wrap}',
    '.notice-wrap .field{flex:1;min-width:140px}',
    '.notice-wrap .field label{font-size:10px;color:#555;display:block;margin-bottom:2px}',
    '.notice-wrap .field .val{border-bottom:1px solid #000;padding:3px 2px;min-height:18px;font-size:12px}',
    '.notice-wrap .highlight{background:#f5f5f5;border:1px solid #ccc;border-radius:4px;padding:10px;margin:12px 0;font-size:13px}',
    '.notice-wrap .reason-box{border:1px solid #ccc;border-radius:4px;padding:8px 12px;margin:6px 0;background:#fafafa;font-size:12px}',
    '.notice-wrap .legal{font-size:11px;color:#444;line-height:1.6;margin-top:16px;border-top:1px solid #ccc;padding-top:10px}',
    '.notice-wrap .sig-row{display:flex;gap:32px;margin-top:24px}',
    '.notice-wrap .sig-block{flex:1;border-top:1px solid #000;padding-top:4px;font-size:10px}',
    '.notice-wrap .watermark{text-align:center;font-size:10px;color:#aaa;margin-top:24px}',
    '.notice-wrap table{width:100%;border-collapse:collapse}',
    '.notice-wrap th{background:#f0f0f0;padding:7px;border:1px solid #ccc;font-size:11px;text-align:left}',
    '.notice-wrap tr td{padding:7px;border:1px solid #ccc;font-size:12px}',
    '.footer{font-size:11px;color:#999;margin-top:16px;text-align:center}',
    '</style></head><body>',
    '<div class="wrap">',
    '<div class="top">',
    '<div class="logo">prop<span>desk</span></div>',
    '<div class="sub">Official Notice: ' + noticeType + '</div>',
    '</div>',
    '<div class="body">',
    '<p class="intro">Dear ' + toName + ',<br/>Please find your <strong>' + noticeType + '</strong> for <strong>' + property + '</strong>, Unit <strong>' + unit + '</strong>. Effective date: <strong>' + effectiveDate + '</strong>.</p>',
    '<div class="notice-wrap">',
    noticeHtml
      .replace(/<!DOCTYPE[^>]*>/gi, '')
      .replace(/<html[^>]*>/gi, '')
      .replace(/<\/html>/gi, '')
      .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
      .replace(/<body[^>]*>/gi, '')
      .replace(/<\/body>/gi, '')
      .trim(),
    '</div>',
    '<p class="intro" style="margin-top:16px"><strong>Served by:</strong> ' + landlordName + '<br/><strong>Date served:</strong> ' + new Date().toLocaleDateString('en-CA') + '</p>',
    '<div style="background:#fff8f0;border:1px solid #E8622A33;border-radius:6px;padding:12px 16px;margin-bottom:16px;font-size:12px;color:#666">',
    '<strong style="color:#333">Important:</strong> This is an official notice under the BC Residential Tenancy Act. ',
    'To dispute, contact the Residential Tenancy Branch at <strong>1-800-665-8779</strong> or visit <a href="https://www.gov.bc.ca/landlordtenant" style="color:#E8622A">gov.bc.ca/landlordtenant</a>.',
    '</div>',
    '<p class="footer">Generated by PropDesk Property Management &middot; propdesk.ca</p>',
    '</div></div>',
    '</body></html>'
  ].join('\n');
};

export const sendNoticeEmail = async (params) => {
  var toEmail       = params.toEmail;
  var toName        = params.toName;
  var noticeType    = params.noticeType;
  var property      = params.property;
  var unit          = params.unit;
  var effectiveDate = params.effectiveDate;
  var landlordName  = params.landlordName;
  var noticeHtml    = params.noticeHtml || '';

  var NOTICE_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_NOTICE_TEMPLATE_ID || EMAILJS_CONFIG.TEMPLATE_ID;

  if (!EMAILJS_CONFIG.SERVICE_ID) {
    console.log('EmailJS not configured - skipping notice email.');
    return { success: false, reason: 'not_configured' };
  }

  var emailHtml = buildNoticeEmailHtml(noticeHtml, toName, noticeType, property, unit, effectiveDate, landlordName);

  try {
    if (!window.emailjs) await loadEmailJSScript();
    window.emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
    await window.emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      NOTICE_TEMPLATE_ID,
      {
        to_email:       toEmail,
        to_name:        toName,
        notice_type:    noticeType,
        property:       property,
        unit:           unit,
        effective_date: effectiveDate,
        landlord_name:  landlordName,
        notice_body:    emailHtml,
        sent_date:      new Date().toLocaleDateString('en-CA'),
      }
    );
    console.log('Notice email sent to:', toEmail);
    return { success: true, sentAt: new Date().toISOString() };
  } catch (error) {
    console.error('Notice email failed:', error);
    return { success: false, reason: error.message };
  }
};

// ── Lead Notification (emails YOU when a new lead comes in) ──────────────

export const sendLeadNotification = async (lead) => {
  if (!EMAILJS_CONFIG.SERVICE_ID) {
    console.log('EmailJS not configured - skipping lead notification.');
    return { success: false, reason: 'not_configured' };
  }
  try {
    if (!window.emailjs) await loadEmailJSScript();
    window.emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
    await window.emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      {
        to_email:    EMAILJS_CONFIG.MANAGER_EMAIL,
        from_name:   lead.name || 'New Lead',
        ticket_id:   'LEAD',
        title:       'New Lead from BC Rent Calculator',
        property:    lead.properties ? lead.properties + ' properties' : 'Not specified',
        unit:        lead.source || 'calculator',
        category:    'Lead Capture',
        priority:    'HIGH',
        description: [
          'Name: ' + (lead.name || 'Not provided'),
          'Email: ' + lead.email,
          'Properties: ' + (lead.properties || 'Not specified'),
          'Current Rent: ' + (lead.currentRent ? '$' + lead.currentRent : 'Not entered'),
          'Source: ' + (lead.source || 'calculator'),
          'Time: ' + new Date().toLocaleString('en-CA'),
        ].join('\n'),
        date:        new Date().toISOString().split('T')[0],
        photo_count: 0,
      }
    );
    console.log('Lead notification sent to:', EMAILJS_CONFIG.MANAGER_EMAIL);
    return { success: true };
  } catch (error) {
    console.error('Lead notification failed:', error);
    return { success: false, reason: error.message };
  }
};

// -- Resolution Email (sent to renter when ticket is resolved) -------------

export const sendResolutionEmail = async (ticket, renterEmail, propertyAddress) => {
  if (!EMAILJS_CONFIG.SERVICE_ID) {
    console.log('EmailJS not configured - skipping resolution email.');
    return { success: false, reason: 'not_configured' };
  }
  if (!renterEmail) {
    console.log('No renter email - skipping resolution email.');
    return { success: false, reason: 'no_email' };
  }

  var NOTICE_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_NOTICE_TEMPLATE_ID || EMAILJS_CONFIG.TEMPLATE_ID;

  var emailHtml = [
    '<!DOCTYPE html><html><head><meta charset="utf-8"/></head>',
    '<body style="font-family:Arial,sans-serif;font-size:13px;color:#1a1a1a;margin:0;padding:20px;background:#f4f4f4">',
    '<div style="max-width:600px;margin:0 auto;background:#fff;border-radius:8px;overflow:hidden">',
    '<div style="background:#1a1a1a;padding:20px 28px">',
    '<span style="font-size:20px;font-weight:800;color:#fff">prop</span><span style="font-size:20px;font-weight:800;color:#E8622A">desk</span>',
    '</div>',
    '<div style="padding:28px">',
    '<div style="display:inline-block;background:#22AA5518;color:#22AA55;font-weight:700;font-size:12px;padding:4px 12px;border-radius:99px;margin-bottom:16px">RESOLVED</div>',
    '<h2 style="margin:0 0 8px;font-size:18px">Your request has been resolved</h2>',
    '<p style="color:#555;margin:0 0 20px">Hi ' + (ticket.renter || 'there') + ', your maintenance request has been marked as resolved.</p>',
    '<div style="background:#f8f8f8;border-radius:8px;padding:16px;margin-bottom:20px">',
    '<div style="margin-bottom:8px"><b>Request:</b> ' + ticket.title + '</div>',
    '<div style="margin-bottom:8px"><b>Property:</b> ' + (propertyAddress || '') + '</div>',
    '<div style="margin-bottom:8px"><b>Unit:</b> ' + (ticket.unit || '') + '</div>',
    '<div><b>Category:</b> ' + (ticket.category || '') + '</div>',
    '</div>',
    '<p style="color:#555;margin:0 0 20px">If the issue persists or you have concerns, please submit a new ticket through your PropDesk portal or contact us directly.</p>',
    '<a href="https://www.propdesk.ca" style="display:inline-block;background:#E8622A;color:#fff;padding:10px 24px;border-radius:8px;text-decoration:none;font-weight:700;font-size:13px">View My Portal</a>',
    '</div>',
    '<div style="padding:16px 28px;background:#f8f8f8;font-size:11px;color:#999;text-align:center">PropDesk Property Management &bull; propdesk.ca &bull; Vancouver, BC</div>',
    '</div></body></html>',
  ].join('');

  try {
    if (!window.emailjs) await loadEmailJSScript();
    window.emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
    await window.emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      NOTICE_TEMPLATE_ID,
      {
        to_email:       renterEmail,
        to_name:        ticket.renter || 'Tenant',
        notice_type:    'Ticket Resolved',
        property:       propertyAddress || '',
        unit:           ticket.unit || '',
        effective_date: new Date().toLocaleDateString('en-CA'),
        landlord_name:  'PropDesk Property Management',
        notice_body:    emailHtml,
        sent_date:      new Date().toLocaleDateString('en-CA'),
      }
    );
    console.log('Resolution email sent to:', renterEmail);
    return { success: true };
  } catch (error) {
    console.error('Resolution email failed:', error);
    return { success: false, reason: error.message };
  }
};
